export default {
  commitProduct(state, product) {
    state.product = product
  },
  setSelectedSku(state, sku) {
    state.selectedSku = sku
  },
  setSelectedPayMethod(state, peyMethod) {
    state.selectedPayMethod = peyMethod
  },
  setIsCzjSpu(state, isCzj) {
    state.isCzjSpu = isCzj
  },
  setIsRedirect(state, isRedirect) {
    state.isRedirect = isRedirect
  },
  setQuestions(state, questionArr) {
    state.questionList = questionArr
  },
  setExplanation(state, arr) {
    state.serveExplanation = arr
  },
  // 设置排班人员数据
  setWorkers(state, workers) {
    state.workers = workers
  },
  reSetWorkers(state) {
    state.workers = []
  },
  setSelectedWorker(state, worker) {
    state.selectedWorker = { ...worker }
  },
  setSelectedTime(state, time) {
    state.selectedTime = time
  },
  setArrowState(state, isShow) {
    state.needArrow = isShow
  },
  setSelectedAddress(state, address) {
    state.selectedAddress = { ...address }
  },
  setUnWorkDays(state, days) {
    state.unworkDays = days
  },
  setWorkDays(state, days) {
    state.workDays = days
  },
  setLookMonths(state, lookMonths) {
    state.lookMonths = lookMonths
  },
  setOtherServiceDatas(state, otherServiceDatas) {
    state.otherServiceDatas = otherServiceDatas
  },
  setFullDays(state, days) {
    state.fullDays = days
  },
  reSetUnWorkDays(state, days) {
    state.unworkDays = []
  },
  setLocationInfo(state, info) {
    state.locationInfo = info
  },
  setComments(state, comments) {
    state.comments.push(...(comments || []))
  },
  setCommentCount(state, count) {
    state.commentCount = count
  },
  setCommentPraiseRate(state, praiseRate) {
    state.praiseRate = praiseRate
  },
  reSetComments(state) {
    state.comments = []
  },
  setTip(state, obj) {
    state.tip = obj
  },
  setMainConfig(state, config) {
    state.mainConfig = config
  },
  setStoreServices(state, lists) {
    state.storeServices.push(...(lists || []))
  },
  reSetStoreServices(state) {
    state.storeServices = []
  }
}
